interface Props {
  values: number[];
  width?: number;
  height?: number;
  className?: string;
}

/** Minimal trend sparkline (SVG polyline). Renders nothing for <2 points. */
export function Sparkline({ values, width = 56, height = 16, className }: Props) {
  if (!values || values.length < 2) return null;
  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const stepX = width / (values.length - 1);
  const points = values
    .map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / span) * height; // invert: higher value = higher on screen
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  const rising = values[values.length - 1] >= values[0];
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      <polyline
        points={points}
        fill="none"
        strokeWidth={1.5}
        className={rising ? 'stroke-success-600' : 'stroke-error-600'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
